import React, { ReactElement } from 'react';
import logo from '../../../assets/png/everylive_logo.png';
import './DownloadAppBanner.scss';
import MobileDetect from 'mobile-detect';
import { appStoreUrl, playStoreUrl } from '../../../common/config/const';

const DownLoadAppBanner = (): ReactElement => {
  const md = new MobileDetect(window.navigator.userAgent);

  const handleDirectToStore = () => {
    if (md.os() === 'AndroidOS') {
      window.location.href = decodeURIComponent(playStoreUrl);
    } else if (md.os() === 'iOS') {
      window.location.href = decodeURIComponent(appStoreUrl);
    }
  };

  return (
    <div className="download-app-banner-root">
      <div className="download-app-banner">
        <div className="download-app-banner-logo">
          <img src={logo} alt="logo-download-app" />
        </div>
        <span className="download-app-banner-title">
          everylive をダウンロード
        </span>
        <button
          onClick={handleDirectToStore}
          className="download-app-banner-button"
        >
          ダウンロード
        </button>
      </div>
    </div>
  );
};
export default DownLoadAppBanner;
